import { beforeEnterHasPerm } from '@/components/PermissionHelper'

const beforeEnter = (to, from, next) => { return beforeEnterHasPerm(to, from, next) }

const ROUTES = {
  TASK_STATE_LIST: 'task-task-state'
}

const routes = [
  {
    path: 'task-state/',
    name: ROUTES.TASK_STATE_LIST,
    beforeEnter: beforeEnter,
    meta: {
      permissions: ['tasks_taskstate_list'],
      requiresAuth: true
    },
    component: () => import('./TaskStateList.vue')
  }
]

export { routes, ROUTES }
